import styled from 'styled-components';
import { white, contiOrange, neutral } from '../../../style/colors';

const OrderButton = styled.button`
  margin-top: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  background-color: ${({ disabled }) => (disabled ? neutral[300] : contiOrange)};
  color: ${white};
  padding: 14px 24px;
  font-size: 15px;
  font-weight: 600;
  border: none;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  border-radius: 10px;
  width: 100%;
  box-shadow: ${({ disabled }) =>
    disabled ? 'none' : '0 2px 8px rgba(255, 165, 0, 0.15)'};

  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 165, 0, 0.25);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  i {
    font-size: 20px;
  }
`;

export default OrderButton;
